import React, {Fragment, useMemo, useState} from "react";

import {useTranslation} from "react-i18next";

import AddButton from "@components/buttons/AddButton";
import EmptyData from "@components/tailwindComponents/EmptyData";

import {reactMemo} from "@helpers/retyped-functions";

import Filter from "./Filter";
import IndividualObjectiveList from "./IndividualObjectiveList";
import ModalUpsertIndividualObjective from "./subComponents/ModalUpsertIndividualObjective";

/**
 *
 * @param {Object} props
 * @param {Object} props.periodList
 * @param {string} props.selectedEmployee
 * @param {boolean=} props.readOnly
 * @param {boolean} props.isMyEmployeeSpace
 * @returns
 */
function IndividualObjetives(props) {
  const {
    periodList,
    selectedEmployee,
    readOnly = false,
    isMyEmployeeSpace = false
  } = props;
  const {t: translator} = useTranslation("assesment.frequency");
  
  const [filterValue, setFilterValue] = useState({
    nameSearch: "",
    objectivePeriods: [],
    objectiveTypes: []
  });
  
  const objectiveIncludeText = (text) => (individualObjective) => {
    if (
      individualObjective.designation.toLocaleLowerCase().includes(text) ||
      individualObjective.comment.toLocaleLowerCase().includes(text)
    ) {
      return true;
    }
    
    return false;
  };
  
  const objectiveHasType = (objectiveTypes) => (individualObjective) => {
    if (objectiveTypes.includes(individualObjective.objectiveType?._id)) {
      return true;
    }
    
    return false;
  };
  
  const filteredPeriodList = useMemo(() => {
    return periodList
      .filter(
        (periodItem) =>
          !filterValue.objectivePeriods.length ||
          filterValue.objectivePeriods.includes(periodItem._id)
      )
      .map((periodItem) => {
        let individualObjectives = [...periodItem.individualObjectives];
        
        if (filterValue.nameSearch) {
          const needle = filterValue.nameSearch.toLocaleLowerCase();
          individualObjectives = individualObjectives.filter(
            objectiveIncludeText(needle)
          );
        }
        
        if (filterValue.objectiveTypes.length) {
          individualObjectives = individualObjectives.filter(
            objectiveHasType(filterValue.objectiveTypes)
          );
        }
        
        return {
          ...periodItem,
          individualObjectives
        };
      });
  }, [periodList, filterValue]);
  
  const [modalUpsertVisible, setModalUpsertVisible] = useState(false);
  const [selectedIndividualObjective, setSelectedIndividualObjective] =
    useState(null);
  
  function toggleModalUpsert(individualObjective = null) {
    setSelectedIndividualObjective(individualObjective);
    setModalUpsertVisible((prevstate) => !prevstate);
  }
  
  return (
    <>
      <div className="arh-w-full arh-px-9 arh-pb-8">
        {(!readOnly && !isMyEmployeeSpace) && (
          <div className="arh-ml-0">
            <AddButton
              label={translator("Ajouter un nouvel objectif ou suivi")}
              onClick={() => toggleModalUpsert()}
              color="arh-bg-greenColor hover:arh-bg-darkGreenColor"
            />
          </div>
        )}
        <Filter setFilterValue={setFilterValue}/>
        <div className="arh-mt-2 arh-flex arh-flex-col arh-space-y-1">
          {!filteredPeriodList.length ? (
            <EmptyData>{translator("Aucun résultat à afficher")}</EmptyData>
          ) : (
            filteredPeriodList.map((period) => (
              <IndividualObjectiveList
                key={period._id}
                periodName={period.name}
                individualObjectiveList={period.individualObjectives}
                onUpdateObjective={toggleModalUpsert}
                readOnly={readOnly}
                isMyEmployeeSpace={isMyEmployeeSpace}
              />
            ))
          )}
        </div>
      </div>
      
      <ModalUpsertIndividualObjective
        isOpen={modalUpsertVisible}
        fragment={Fragment}
        onClickClose={toggleModalUpsert}
        individualObjective={selectedIndividualObjective}
        selectedEmployee={selectedEmployee}
        isMyEmployeeSpace={isMyEmployeeSpace}
      />
    </>
  );
}

export default reactMemo(IndividualObjetives);
